<template>
    <div>
        <div class="container-fluid home-top-bar">
            <div class="content__wrapper">
                <header>
                <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
                    <a class="navbar-brand" href="javascript:void(0)">
                    <img src="@/assets/images/header_logo.png" alt="Logo" />
                    </a>
                    <button
                    class="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    >
                    <span class="navbar-toggler-icon"></span>
                    </button>

                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav mr-auto d-none">
                        <li class="nav-item">
                        <a class="nav-link" href="#">Find Parking</a>
                        </li>
                        <li class="nav-item">
                        <a class="nav-link" href="#">Parking Management</a>
                        </li>
                        <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDropdown"
                            role="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >Solutions For</a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item" href="#">Solutions 1</a>
                            <a class="dropdown-item" href="#">Solutions 2</a>
                        </div>
                        </li>
                    </ul>
                    <div class="form-inline my-2 my-lg-0">
                        <ul class="navbar-nav mr-auto align-items-center d-none">
                        <!-- <li class="nav-item">
                            <a class="nav-link" href="#">App Download</a>
                        </li>-->
                        <li class="nav-item border-dark">
                            <router-link class="nav-link" to="/login">Client Login</router-link>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link btn txt--s txt--bold" href="#">Get In Touch</a>
                        </li>
                        </ul>
                    </div>
                    </div>
                </nav>
                </header>
            </div>
            </div>

            <div id="banner" style>
            <div class="container-fluid banner-text">
                <div class="content__wrapper">
                <div class="row">
                    <div class="col-lg-6 col-xl-5 pl-5 mx-auto">
                    <h1 class="txt--bold">The World’s Smartest Parking Company</h1>
                    <p class="txt--s para-text pt-4">
                        Pied Parker is the meeting point between AI, edge computing, and
                        mobility. Pied gives drivers and vehicles a brand new payment
                        and identification that saves them minutes on any travel and
                        efficientcy for parking managers.
                    </p>
                    <a href="#" class="button button--lg button--white txt--bold mt-5 d-none">Get In Touch</a>
                    <a
                        href="#"
                        class="button button--lg bt-border button--white ml-3 txt--bold mt-3 mt-md-4 mt-lg-5 d-none"
                    >Watch Video</a>
                    </div>
                </div>
                </div>
            </div>
            <!-- <div class="banner-imgbox">
                <img class="img-fluid" src="@/assets/images/Desktop.png" alt="Logo" />
                <img class="img-fluid" src="@/assets/images/Phone.png" alt="Logo" />
            </div>-->
            </div>

            <div class="container-fluid home-body-content">
            <div class="content__wrapper">
                <!-- <div class="row">
                <div class="content-box col-md-8 col-lg-6 col-xl-5 pl-5 mb-4">
                    <img class="img-fluid" src="@/assets/images/Desktop-Copy2.png" alt />
                    <h2 class="txt--bold mt-lg-4 mt-3">
                    The World’s Smartest.
                    <br />Parking Company.
                    </h2>
                    <p class="txt--s para-text pt-4">
                    Pied Parker is offers frictionless payment and user experience
                    which is much more than starting and stopping a transaction. It
                    does this and manages smarter by building self-contained
                    technology that works around integration and an open parking
                    ecosystem.
                    </p>
                    <a href="#" class="button button--lg button--white txt--bold mt-4">Learn More</a>
                </div>

                <div class="col-xl-1 d-none d-xl-block"></div>

                <div class="content-box col-md-8 col-lg-6 col-xl-5 pl-5 mb-4">
                    <img class="img-fluid" src="@/assets/images/Group16.png" alt />
                    <h2 class="txt--bold mt-lg-4 mt-3">
                    Let’s get you parked simpler
                    <br />and easier with Pied Parker
                    </h2>
                    <p class="txt--s para-text pt-4">
                    Cum sociis natoque penatibus et magnis dis parturient montes,
                    nascetur ridiculus mus. Duis mollis, est non commodo luctus, nisi
                    erat porttitor ligula, eget lacinia odio sem nec elit. Nulla vitae
                    elit libero, a pharetra augue. Nullam quis risus eget urna mollis
                    ornare vel eu leo.
                    </p>
                    <a href="#" class="button button--lg button--white txt--bold mt-4">Learn More</a>
                </div>
                </div>

                <div class="row mt-lg-5 pt-md-5 pt-2 mt-2">
                <div class="col-md-6 content-box col-lg-6 col-xl-5 pl-5 mb-4">
                    <h3 class="txt--bold txt--fslg mt-lg-4 mt-3">Ready to get started?</h3>
                    <p class="txt--s para-text">
                    Get in touch and a product specialist will get back to you
                    shortly.
                    </p>
                    <a href="#" class="button button--lg button--white txt--bold mt-4">Get In Touch</a>
                </div>

                <div class="col-xl-1 d-none d-xl-block"></div>

                <div class="col-md-6 content-box col-lg-6 col-xl-5 pl-5 mb-4">
                    <h3 class="txt--bold txt--fslg mt-lg-4 mt-3">Get the latest</h3>
                    <p class="txt--s para-text">Cras justo odio, dapibus ac facilisis in, egestas eget quam.</p>

                    <form class="mt-4">
                    <div class="form-row">
                        <div class="col-10">
                        <input type="email" class="form-control custom" placeholder="Email address" />
                        </div>
                        <div class="col">
                        <button class="button--white circle-btn txt--bold">
                            <i class="fas fa-chevron-right"></i>
                        </button>
                        </div>
                    </div>
                    </form>
                </div>
                </div>-->

                <footer>
                <div class="row justify-content-between align-items-center">
                    <div class="col-auto d-flex align-items-center">
                    <p>
                        <img src="@/assets/images/header_logo.svg" alt="Logo" />
                    </p>
                    <p class="txt--ss para-text pl-4 pt-1">© 2020 Pied, Inc. All rights reserved.</p>
                    </div>

                    <div class="col-auto d-flex align-items-center">
                    <ul class="d-flex align-items-center">
                        <li class="px-3 txt--fslg">
                        <a class="txt-white" href="#">
                            <i class="fab fa-instagram"></i>
                        </a>
                        </li>
                        <li class="px-3 txt--fslg">
                        <a class="txt-white" href="#">
                            <i class="fab fa-facebook-f"></i>
                        </a>
                        </li>
                        <li class="px-3 txt--fslg">
                        <a class="txt-white" href="#">
                            <i class="fab fa-twitter"></i>
                        </a>
                        </li>
                    </ul>
                    </div>
                </div>
                </footer>
            </div>
            </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            token_id : '',

        }
    },
    created()
    {
        this.token_id = this.$route.query.tok ;
        this.verifyEmail();
    },
    methods: {
        verifyEmail()
        {
            this.axios.post(window.hostname+'/api/auth/verify-email-link',{
                device_type : 1 ,
                token_id : this.token_id ,
            })
            .then(res=>{
                console.log(res);
                if(res.data.status)
                {
                    this.$toasted.show('Email Verified successfully!',{
                        icon : 'check-circle',
                        className : 'success-class'
                    });
                    this.$nextTick(()=>{
                        this.$router.push({
                            name :'Login'
                        });
                    });
                }
                else
                {
                    this.$toasted.show(res.data.message,{
                        icon : 'times-circle',
                        className : 'error-class'
                    });
                    this.$nextTick(()=>{
                        this.$router.push({
                            name :'Login'
                        });
                    });
                }
            })
            .catch(err=>{
                this.$toasted.show(err.response.data.message,{
                    icon : 'times-circle',
                    className : 'error-class'
                });
                this.$nextTick(()=>{
                    this.$router.push({
                        name :'Login'
                    });
                });
            });
        }
    }
}
</script>